import { createModel } from '@rematch/core';
import { post } from 'utils/http';

export default createModel()({
  state: {},
  reducers: {
    setState: (state: any, payload: any) => ({ ...state, ...payload }),
  },
  effects: {
    // 上传音频
    async uploadFile(file: File) {
      const formData = new FormData();
      formData.append('file', file);

      const rst = await post('/api/upload/uploadFile', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      return rst;
    },
  },
});
